"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateCatalog = void 0;
const react_1 = require("@apollo/client/react");
const create_catalog_mutation_1 = require("./create-catalog.mutation");
const useCreateCatalog = (projectId) => {
    const [createCatalog, data] = (0, react_1.useMutation)(create_catalog_mutation_1.CREATE_CATALOG, { variables: { project: projectId, title: '', description: '' } });
    return Object.assign({ createCatalog }, data);
};
exports.useCreateCatalog = useCreateCatalog;
exports.default = exports.useCreateCatalog;
